<template>
	<b-container fluid class="no-padding">
		<b-row class="my-1 stencilform">

			<b-col lg="8" sm="12" class="stencilform-previews no-padding" id="stencilform-previews">
				<preview-form></preview-form>
			</b-col>

			<b-col lg="4" class="stencilform-tools no-padding">
                <div role="tablist" class="stencilform-mobile">
                    <b-card no-body>
                        <b-card-header header-tag="header" class="p-1" role="tab">
                            <b-btn block href="#" v-b-toggle.accordion1 variant="info"><i class="fa fa-font"></i><span>font</span></b-btn>
                        </b-card-header>
                        <b-collapse id="accordion1" visible accordion="my-accordion" role="tabpanel">
                            <step-font></step-font>
                        </b-collapse>
                    </b-card>
                    <b-card no-body>
                        <b-card-header header-tag="header" class="p-1" role="tab">
                            <b-btn block href="#" v-b-toggle.accordion2 variant="info"><i class="fa fa-text-height"></i><span>height</span></b-btn>
                        </b-card-header>
                        <b-collapse id="accordion2" accordion="my-accordion" role="tabpanel">
                            <step-height></step-height>
                        </b-collapse>
                    </b-card>
                    <b-card no-body>
                        <b-card-header header-tag="header" class="p-1" role="tab">
                            <b-btn block href="#" v-b-toggle.accordion3 variant="info"><i class="fa fa-building"></i><span>material</span></b-btn>
                        </b-card-header>
                        <b-collapse id="accordion3" accordion="my-accordion" role="tabpanel">
                            <step-material></step-material>
                        </b-collapse>
                    </b-card>
                    <b-card no-body>
                        <b-card-header header-tag="header" class="p-1" role="tab">
                            <b-btn block href="#" v-b-toggle.accordion4 variant="info"><i class="fa fa-plus"></i><span>quantity</span></b-btn>
                        </b-card-header>
                        <b-collapse id="accordion4" accordion="my-accordion" role="tabpanel">
                            <step-quantity></step-quantity>
                        </b-collapse>
                    </b-card>
                </div>
			</b-col>

		</b-row>
	</b-container>

</template>

<script>
import jQuery from 'jquery'

import previewForm from './stencilease-lc-preview.vue'
import stepFont from './stencilease-lc-step-font.vue'
import stepHeight from './stencilease-lc-step-height.vue'
import stepMaterial from './stencilease-lc-step-material.vue'
import stepQuantity from './stencilease-lc-step-quantity.vue'

export default {
	components: {
		jQuery,
		previewForm,
		stepFont,
		stepHeight,
		stepMaterial,
		stepQuantity
	}
}
</script>